export default "__VITE_PUBLIC_ASSET__2421748b__"